export default "__VITE_ASSET__CMfxUDqw__"